import { _API, _HEADER, _AXIOS_HELPER } from '@/static';
import * as ENUM from "@/enum/lib";

export default {
     getMyPatientsAndReservedSchedulesForToday() {
        return new Promise((resolve, reject) => {
            const url = _API + '/patient/getMyPatientsAndReservedSchedulesForToday';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, {}, conf)
                .then(res => {
                    resolve({
                        ...res,
                        data: {
                            ...res.data,
                            patientList: res.data.patientList.map((item) => {
                                return {
                                    check: item?.isEnabled === true,
                                    ...item,
                                }
                            }),
                        },
                    });
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}